 export interface IOrderHandshakeOffer {
    userId: string;
    digest: string;
}
